<template>
  <span :class="`shipping-list-item-status font-weight-bold rounded-lg ${statusColorVariant}`" v-b-tooltip.hover :title="statusStrings[shipping.status]">
    {{ shipping.status }}
  </span>
</template>

<script>
import constants from '@/common/constants'

export default {
  name: 'ShippingsListItemStatus',
  props: {
    shipping: {
      type: Object,
      required: true
    }
  },
  computed: {
    statusColorVariant() {
      let cssClass
      if (this.shipping.status === 'CANCELED') {
        cssClass = 'text-danger'
      } else if (this.shipping.status === 'INCIDENCE' || this.shipping.status === 'WAITINGCLIENT' || this.shipping.status === 'TOBERETURNED' || (this.shipping.status === 'DRAFT' && this.shipping.fields_revision)) {
        cssClass = 'bg-warning'
      } else if (this.shipping.status === 'BLOCKED' || (this.shipping.status === 'DRAFT' && !this.shipping.fields_revision)) {
        cssClass = 'bg-dark text-white'
      } else if (this.shipping.status === 'DELIVERED' || this.shipping.status === 'RETURNED') {
        cssClass = 'text-success'
      } else {
        cssClass = 'bg-success text-white'
      }
      return cssClass
    }
  },
  mixins: [constants]
}
</script>

<style lang="scss">
.shipping-list-item-status {
  display: inline-block;
  padding: 0 5px;
}
</style>
